import React from 'react'
import {
    Table,
    Card,
  } from "antd";

const Preview = (props) => {
    const columns1 = [
      {
          "key": 1,
          "title": "Details ",
          "dataIndex": "details",
          "width": 500
      }
  ]

  const dataSource = [
    {
      details: "Campaign Name"
    },
    {
      details: "SMS Provider"
    },
    {
      details: "Business Rule"
    },
    {
      details: "Campaign Message"
    } 
  ]
  
    return (
      <Card title={"Preview"}>
         
        <Table
          columns={columns1}
          dataSource={dataSource}
          pagination={false}
        ></Table>
      </Card>
    );
  }

export default Preview